const inverter = [
  {
    "title": "TommaTech Uno Hybrid K Serisi Tek Faz 3.0-7.5kW İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/162_tommatech-uno-hybrid-k-serisi-tek-faz-30-75kw-inverterler.webp",
    "text": "Düşük Voltajda Devreye Girme\nYüksek Verimlilik\nUzaktan İzleme\nIP65 Koruma\nEnerji Depolama Çözümleri",
    "variants": [
      {
        "wp": "7.5 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-k-75kw-tek-faz-inverter-960.html"
      },
      {
        "wp": "6.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-k-60kw-tek-faz-inverter-959.html"
      },
      {
        "wp": "5.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-k-50kw-tek-faz-inverter-958.html"
      },
      {
        "wp": "3.7 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-k-37kw-tek-faz-inverter-957.html"
      },
      {
        "wp": "3.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-k-30kw-tek-faz-inverter-956.html"
      }
    ]
  },
  {
    "title": "TommaTech F Serisi Üç Faz 15.0-20.0kW LV Hibrit İnverter",
    "image": "https://cw-enerji.com/images/kategory_grup/165_tommatech-f-serisi-uc-faz-150-200kw-lv-hibrit-inverter.webp",
    "text": "3 Faz AC Çıkış\nFaz Dengesizliği Ayarı\nGenişletilebilir Sistem\nMaksimum Şarj/Deşarj Akımı\n48V Batarya Çıkış Gerilimi\nJeneratör Destekli",
    "variants": [
      {
        "wp": "20 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-f-serisi-200kw-uc-faz-lv-hibrit-inverter-1537.html"
      },
      {
        "wp": "15 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-f-serisi-150kw-uc-faz-lv-hibrit-inverter-1539.html"
      }
    ]
  },
  {
    "title": "TommaTech Trio Hybrid K Serisi Üç Faz 5.0-15.0kW İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/161_tommatech-trio-hybrid-k-serisi-uc-faz-50-150kw-inverterler.webp",
    "text": "3-Faz Çıkışı\nYüksek Verimlilik\nUzaktan İzleme\nIP65 Dereceli\nEnerji Depolama Çözümleri",
    "variants": [
      {
        "wp": "15.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-k-150kw-uc-faz-inverter-966.html"
      },
      {
        "wp": "12.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-k-120kw-uc-faz-inverter-965.html"
      },
      {
        "wp": "10.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-k-100kw-uc-faz-inverter-964.html"
      },
      {
        "wp": "8.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-k-80kw-uc-faz-inverter-963.html"
      },
      {
        "wp": "6.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-k-60kw-uc-faz-inverter-962.html"
      },
      {
        "wp": "5.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-k-50kw-uc-faz-inverter-961.html"
      }
    ]
  },
  {
    "title": "TommaTech Trio Hybrid Serisi Üç Faz 5.0-10.0kW İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/163_tommatech-trio-hybrid-serisi-uc-faz-50-100kw-inverterler.webp",
    "text": "Yüksek Verimlilik\n3 Faz AC Cıkış\nUzaktan İzleme\nIP65 Koruma\nEnerji Depolama Çözümleri",
    "variants": [
      {
        "wp": "10.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-100kw-uc-faz-inverter-413.html"
      },
      {
        "wp": "8.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-80kw-uc-faz-inverter-118.html"
      },
      {
        "wp": "6.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-60kw-uc-faz-inverter-117.html"
      },
      {
        "wp": "5.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-50kw-uc-faz-inverter-116.html"
      }
    ]
  },
  {
    "title": "TommaTech Uno Hybrid Serisi Tek Faz Dizi 3.0-5.0kW İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/164_tommatech-uno-hybrid-serisi-tek-faz-dizi-30-50kw-inverterler.webp",
    "text": "Yüksek Verimlilik\nGeniş Voltaj Aralığı\nUzaktan İzleme\nIP65 Koruma\nEnerji Depolama Çözümleri",
    "variants": [
      {
        "wp": "4.6 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-46kw-tek-faz-inverter-114.html"
      },
      {
        "wp": "5.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-50kw-tek-faz-inverter-115.html"
      },
      {
        "wp": "3.7 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-37kw-tek-faz-inverter-113.html"
      },
      {
        "wp": "3.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-uno-hybrid-30kw-tek-faz-inverter-634.html"
      }
    ]
  },
  {
    "title": "TommaTech Trio Hybrid M Serisi Üç Faz Dizi 50kW İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/202_tommatech-trio-hybrid-m-serisi-uc-faz-dizi-50kw-inverterler.webp",
    "text": "Yüksek Verimlilik\nUzaktan İzleme\n3 Faz AC Çıkış\nIP65 Koruma\nFaz Dengeleme\n10 Yıl Garanti",
    "variants": [
      {
        "wp": "50 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-m-50w-uc-faz-inverter-1818.html"
      }
    ]
  },
  {
    "title": "TommaTech Trio Hybrid Pro Serisi Üç Faz 4.0-15.0kW İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/212_tommatech-trio-hybrid-pro-serisi-uc-faz-40-150kw-inverterler.webp",
    "text": "Yüksek Performans\nGüvenilir Yedek Güç\nUzaktan İzleme\nJeneratör Uyumluluğu\nÇift HV Akü Bağlantı Noktaları",
    "variants": [
      {
        "wp": "15.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-150kw-uc-faz-inverter-1894.html"
      },
      {
        "wp": "12.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-120kw-uc-faz-inverter-1893.html"
      },
      {
        "wp": "10.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-100kw-uc-faz-inverter-1892.html"
      },
      {
        "wp": "8.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-80kw-uc-faz-inverter-1891.html"
      },
      {
        "wp": "6.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-60kw-uc-faz-inverter-1890.html"
      },
      {
        "wp": "5.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-50kw-uc-faz-inverter-1889.html"
      },
      {
        "wp": "4.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-pro-serisi-40kw-uc-faz-inverter-1888.html"
      }
    ]
  },
  {
    "title": "TommaTech Trio Hybrid Maxi Serisi 60-80kW Üç Faz İnverterler",
    "image": "https://cw-enerji.com/images/kategory_grup/211_tommatech-trio-hybrid-maxi-serisi60-80kwuc-faz-inverterler.webp",
    "text": "Yüksek Verimlilik\nUzaktan İzleme\n3 Faz AC Çıkış\nIP65 Koruma\nFaz Dengeleme\n10 Yıl Garanti",
    "variants": [
      {
        "wp": "80 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-maxi-serisi80kwuc-faz-inverter-1874.html"
      },
      {
        "wp": "75 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-maxi-serisi75kwuc-faz-inverter-1875.html"
      },
      {
        "wp": "70 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-maxi-serisi70kwuc-faz-inverter-1873.html"
      },
      {
        "wp": "60 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-trio-hybrid-maxi-serisi60kwuc-faz-inverter-1872.html"
      }
    ]
  },
  {
    "title": "TommaTech New Pro Serisi İnverterler 1.2-3.0-5.0kW",
    "image": "https://cw-enerji.com/images/kategory_grup/166_tommatech-new-pro-serisi-12-50kw-off-grid-inverterler.webp",
    "text": "Tam Sinüs Dalga Tipi İnverter\nMobil izleme için dahili Wifi\nBMS İçin Ayrılmış İletişim Portu\nGeniş DC Solar Giriş Aralığı\nBataryadan Bağımsız Tasarım\nYüksek Şarj Akımı Desteği\nPil Performansını Optimize Etmek ve Kullanım\nÖmrünü Uzatmak İçin Pil Eşitleme İşlevi\nToz Önleme Kiti",
    "variants": [
      {
        "wp": "5.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechnew-pro-5k-48v-1faz-akilli-inverter-1545.html"
      },
      {
        "wp": "3.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechnew-pro-3k-24v-1faz-akilli-inverter-1544.html"
      },
      {
        "wp": "1.2 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechnew-pro-12k-12v-1faz-akilli-inverter-1542.html"
      }
    ]
  },
  {
    "title": "TommaTech New Serisi İnverterler 1.0-3.0-5.0kW",
    "image": "https://cw-enerji.com/images/kategory_grup/93_tommatech-new-serisi-10-50kw-off-grid-inverterler.webp",
    "text": "Besleme kaynağı olarak Şebeke ve Jeneratör desteği ile çalışması uyumlu\nPWM veya MPPT Seçeneği\nSeçilebilir giriş voltaj aralığı\nHızlı kurulum\nAşırı yük ve kısa devre koruması\nSoğuk başlatma işlevi\nToz önleme kiti",
    "variants": [
      {
        "wp": "MPPT 5 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechnew-5k-48v-mppt-1faz-akilli-inverter-276.html"
      },
      {
        "wp": "NEW 5 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechnew-5k-48v-1faz-akilli-inverter-419.html"
      },
      {
        "wp": "NEW 1 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechnew-1k-12v-1faz-akilli-inverter-422.html"
      },
      {
        "wp": "MPPT 3 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-new-3k-24v-mppt-1faz-akilli-inverter-275.html"
      },
      {
        "wp": "MPPT 1 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-new-1k-12v-mppt-1faz-akilli-inverter-274.html"
      },
      {
        "wp": "NEW 3 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatech-new-3k-24v-1faz-akilli-inverter-17.html"
      }
    ]
  },
  {
    "title": "TommaTech MPlus Serisi İnverterler 3.6-7.2-11kW",
    "image": "https://cw-enerji.com/images/kategory_grup/92_tommatech-m-plus-serisi-36-110kw-off-grid-inverterler.webp",
    "text": "RGB ışıklı özelleştirilebilir LED durum çubuğu\nMobil izleme için dahili wifi\nUSB On-the-Go işlevini destekler\nBMS için ayrılmış iletişim portu\nBataryadan bağımsız tasarım\nBakım kolaylığı için değistirilebilir fan tasarımı\nSeçilebilir yüksek güçlü şarj akımı\nEv aletleri ve kişisel bilgisayarlar için seçilebilir giriş voltaj aralığı\nBesleme kaynağı olarak Şebeke ve Jeneratör desteği ile çalışması uyumlu\nYerleşik toz önleme kiti",
    "variants": [
      {
        "wp": "11.0 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechmplus-11k-48v-mppt-1faz-akilli-inverter-693.html"
      },
      {
        "wp": "7.2 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechmplus-72k-48v-mppt-1faz-akilli-inverter-408.html"
      },
      {
        "wp": "3.6 kW",
        "link": "https://cw-enerji.com/tr/urun/tommatechmplus-36k-24v-mppt-1faz-akilli-inverter-213.html"
      }
    ]
  },
  {
    "title": "0.75kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/1816_075kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Heatpump Controller Box",
    "image": "https://cw-enerji.com/images/product/1432_tommatech-heatpump-controller-box_0.webp",
    "text": "Nakit Tasarrufu\nEkonomik\nUzaktan İzleme\nAkıllı\nBasit&Ergonomik\nTak Çalıştır",
    "variants": []
  },
  {
    "title": "TommaTech Trio - EPS Parallel Box Aksesuar",
    "image": "https://cw-enerji.com/images/product/1775_tommatech-trio-eps-parallel-box-aksesuar_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Booster Paralel BOX",
    "image": "https://cw-enerji.com/images/product/1819_tommatech-booster-paralel-box_0.jpg",
    "text": "Geniş Sıcaklık Aralığında Çalışma\nKüçük ve Hafif Tasarım\nUzaktan İzleme",
    "variants": []
  },
  {
    "title": "TommaTech Trio - EPS Box Aksesuar (Üç Faz için)",
    "image": "https://cw-enerji.com/images/product/350_tommatech-trio-eps-box-aksesuar-uc-faz-icin_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Uno - EPS Box Aksesuar (Tek Faz için)",
    "image": "https://cw-enerji.com/images/product/349_tommatech-uno-eps-box-aksesuar-tek-faz-icin_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "250kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/1449_250kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "185kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/1448_185kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "160kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/1447_160kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "132kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/1446_132kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "110kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/618_110kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "90kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/617_90kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "75kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/616_75kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "55kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/615_55kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "45kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/614_45kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "37kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/613_37kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "30kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/621_30kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "22kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/622_22kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "18.5kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/612_185kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "15kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/623_15kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "7.5-11kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/624_75-11kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "5.5kW Galvaniz IP55 Hazır Sulama Kutusu",
    "image": "https://cw-enerji.com/images/product/620_075-55kw-galvaniz-ip55-hazir-sulama-kutusu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech 250 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/1370_tommatech-250-kw-3-faz380v-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 185 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/1369_tommatech-185-kw-3-faz380v-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 160 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/1368_tommatech-160-kw-3-faz380v-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 132 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/610_tommatech-132-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 110 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/609_tommatech-110-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 90 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/608_tommatech-90-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 75 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/607_tommatech-75-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 55 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/606_tommatech-55-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 45 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/605_tommatech-45-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 37 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/619_tommatech-37-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 30 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/590_tommatech-30-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 22 kW 900VDC 3 Faz/380VAC LED Ekran Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/587_tommatech-22-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 18,5 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/586_tommatech185-kw-3-faz380v-sulama-pompasi-inverteri_0.jpg",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Metal Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 15 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/588_tommatech-15-kw-900vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 15 kW 1000VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/1884_tommatech15-kw-1000vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 11 kW 1000VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/584_tommatech11-kw-1000vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 7,5 kW 1000VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/611_tommatech-75-kw-1000vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 5,5 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/585_tommatech-55-kw-900vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 4 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/583_tommatech4-kw-900vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 2,2 kW 900VDC 3 Faz/380VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/604_tommatech-22-kw-900vdc-3-faz380vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  },
  {
    "title": "TommaTech 2,2 kW 450VDC 1 Faz/220VAC Sulama Pompası İnverteri",
    "image": "https://cw-enerji.com/images/product/591_tommatech-22-kw-450vdc-1-faz220vac-sulama-pompasi-inverteri_0.webp",
    "text": "- Geniş MPPT Çalışma Voltajı Aralığı\n- Fonksiyonel Tuş Takımı\n- Yüksek Kaliteli Bileşenler\n- Dayanıklı Plastik Kasa\n- Farklı Güç Seçenekleri",
    "variants": []
  }
];

export default inverter;
